export interface TransformRequestBirthCitizenshipDeathParmas {
  year?: string;
  surname?: string;
  code?: string;
  name?: string;
  documentNumber?: string;
  numReg?: string;
  parte?: string;
  serie?: string;
}

export interface TransformResponseBirthCitizenshipDeathParmas {
  anno?: string;
  cognome?: string;
  matricola?: string;
  nome?: string;
  numeroAtto?: string;
  numeroRegistro?: string;
  parte?: string;
  serie?: string;
}
export const transformRequestBirthCitizenshipDeath = (
  values: TransformRequestBirthCitizenshipDeathParmas | null
): TransformResponseBirthCitizenshipDeathParmas => {
  return {
    anno: values?.year || undefined,
    cognome: values?.surname || undefined,
    matricola: values?.code || undefined,
    nome: values?.name || undefined,
    numeroAtto: values?.documentNumber || undefined,
    numeroRegistro: values?.numReg || undefined,
    parte: values?.parte || undefined,
    serie: values?.serie || undefined,
  };
};
